module.exports = __webpack_public_path__ + "img/s2.5437ca55.svg";